export default
{
    name: 'app-header',

    data()
    {
        return {
            filterLabelIsVisible: false,
            isVisible: false,
            activeColor: 'white'
        }
    },

    created()
    {
        this.eventHub.$on('app-header:show-filter', this._showFilterLabel)
        this.eventHub.$on('app-header:hide-filter', this._hideFilterLabel)
        this.eventHub.$on('app-header:hide-header', this._hideHeader)
        this.eventHub.$on('app-header:show-header', this._showHeader)
        this.eventHub.$on('app-header:change-color', this._changeActiveColor)
    },

    destroyed()
    {
        this.eventHub.$off('app-header:show-filter', this._showFilterLabel)
        this.eventHub.$off('app-header:hide-filter', this._hideFilterLabel)
        this.eventHub.$off('app-header:hide-header', this._hideHeader)
        this.eventHub.$off('app-header:show-header', this._showHeader)
        this.eventHub.$off('app-header:change-color', this._changeActiveColor)
    },

    methods:
    {
        // ACTIONS
        _showFilters()
        {
            this._hideFilterLabel()

            this.eventHub.$emit('page-home:show-filters-section')
        },

        _showFilterLabel()
        {
            this.filterLabelIsVisible = true
        },

        _hideFilterLabel()
        {
            this.filterLabelIsVisible = false
        },

        _showHeader()
        {
            this.isVisible = true
        },

        _hideHeader()
        {
            this.isVisible = false
        },

        _changeActiveColor(color = 'dark')
        {
            this.activeColor = color
        },

        // HTML ACTIONS
        _onClickOnClose()
        {
            let route = this.$root.urlHistory[this.$root.urlHistory.length - 1 - 1]
            if (this.$root.urlHistory[this.$root.urlHistory.length - 1].name !== this.$root.CONFIG.pages.about.name)
            {
                route = this.$root.urlHistory[this.$root.urlHistory.length - 1]
            }

            this.$router.push(route ? route.path : this.$root.getPageURLFromName('home'))
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-header/script.js